import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CreateFleetUserDialogData, CreateFleetUserRequest, CreateFleetUserResponse, ErmDevOpsApiClientService } from 'erm-sdk';

@Component({
  standalone: false,
  selector: 'app-create-fleet-user',
  templateUrl: './create-fleet-user.component.html',
  styleUrls: ['./create-fleet-user.component.scss']
})
export class CreateFleetUserComponent {

  isSaving: boolean = false;
  customerId?: string;
  userEmail?: string;
  createFleetUserRequest: CreateFleetUserRequest;
  createFleetUserResponse?: CreateFleetUserResponse;

  constructor(private ermDevOpsApiClient: ErmDevOpsApiClientService,
    @Inject(MAT_DIALOG_DATA) public createFleetUserDialogData: CreateFleetUserDialogData,
    public dialogRef: MatDialogRef<CreateFleetUserComponent>) {
    this.customerId = createFleetUserDialogData.customerId;
    this.createFleetUserRequest = {
      customerId: createFleetUserDialogData.customerId,
      isEnabled: false,
      allowList: ["*"]
    };
  }

  async save(): Promise<void> {
    try {
      this.createFleetUserRequest.userEmail = this.userEmail;
      if (!this.createFleetUserRequest.userEmail?.includes('@')) {
        alert(`Invalid Email`);
        return;
      }
      this.isSaving = true;
      const createFleetUserResponse = await this.ermDevOpsApiClient.createFleetUser(this.createFleetUserRequest);
      this.createFleetUserResponse = createFleetUserResponse.body as CreateFleetUserResponse;
    } finally {
      this.isSaving = false;
    }
  }

  close(): void {
    this.dialogRef.close({ data: this.createFleetUserResponse?.fleetUser });
  }
}
